import React from "react"

import styled from "styled-components"

import SEO from "./seo"
import PageHeader from "./pageHeader"

export default ({ title, subtitle, description, titleElement, fluid, children }) => {
  return (
    <>
      <SEO title={title} description={description} />
      <PageHeader
        title={title}
        titleElement={titleElement}
        subtitle={subtitle}
        fluid={fluid}
      />
      <Page>{children}</Page>
    </>
  )
}

const Page = styled.div`
  --maxWidth: ${({ theme }) => theme.maxWidth}px;
  display: grid;
  grid-template-columns: minmax(0.5rem, 1fr) minmax(auto, var(--maxWidth)) minmax(
      0.5rem,
      1fr
    );
  padding: 0 0 2rem 0;
`
